"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AspectRatioShell_1 = __importDefault(require("../AspectRatioShell"));
var ImageInputContext_1 = require("../../ImageInputContext");
var smallImageInputUIConditionsMet_1 = require("../ImageEditor/utils/smallImageInputUIConditionsMet");
var icons_1 = require("../../../../icons");
var themes_1 = require("../../../../themes");
var Typo_1 = require("../../../Typo");
var FileUploadWrapper_1 = require("../../../FileUploadWrapper");
var ModalConfirm_1 = require("../../../Modals/ModalConfirm");
var genIcon_1 = require("../../../Dropdowns/utils/genIcon");
var styled_1 = require("./styled");
var utilsOolib_1 = require("../../../../utilsOolib");
var ImageSquare = icons_1.icons.ImageSquare;
var greyColor100 = themes_1.colors.greyColor100;
var Placeholder = function (_a) {
    var aspectRatioProp = _a.aspectRatio;
    var _b = (0, ImageInputContext_1.useImageInputContext)(), aspectRatioFromContext = _b.aspectRatio, containerShape = _b.containerShape, uploadProgress = _b.uploadProgress, isLoading = _b.isLoading, dropzoneLabel = _b.dropzoneLabel, dropzoneSublabel = _b.dropzoneSublabel, stretchToFullHeight = _b.stretchToFullHeight, multiple = _b.multiple, showOptionalLabelInDropzone = _b.showOptionalLabelInDropzone, isRequired = _b.isRequired, showImageUploadCaution = _b.showImageUploadCaution, uploadArgs = _b.uploadArgs, showModal = _b.showModal, setShowModal = _b.setShowModal;
    /** cuz in inlineimageinput we define an explicit aspect ratio for the placeholder only. since the image doesnt need an aspect ratio container */
    var aspectRatio = aspectRatioProp || aspectRatioFromContext;
    var styledPlaceholderWrapperRef = (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)(false), smallPlaceholderUI = _c[0], setSmallPlaceholderUI = _c[1];
    var decideUIStyle = function () {
        // This function makes sure that we have received actual width and height from AspectRatioShell comp, 
        // onShellPrepared is the function that is getting called inside AspectRatioShell Comp to determine height and width of shell based on wrapper-Width and stretchToFullHeight prop inside <AspectRatioShell/> Comp
        var width = styledPlaceholderWrapperRef.current.getBoundingClientRect().width;
        if ((0, smallImageInputUIConditionsMet_1.smallImageInputUIConditionsMet)({ width: width, containerShape: containerShape })) {
            setSmallPlaceholderUI(true);
        }
        else {
            setSmallPlaceholderUI(false);
        }
    };
    /**
     * placeholder is shown only if:
     * - no value is passed to the SingleImageInput
     * - OR value is there, but the current image is being replaced
     * In all other cases, i.e value exists and THIS image is not currently being replaced,
     * then that image is rendered instead of placeholder
     *
     */
    // const [dragOverActive, setDragOverActive] = useState(false)
    var _d = (0, ImageInputContext_1.useImageInputContext)(), handleUpload = _d.handleUpload, onChange = _d.onChange, value = _d.value, id = _d.id;
    var inputRef = (0, react_1.useRef)(null);
    var handleOnConfirm = function () {
        localStorage.setItem("PreUploadImageCautionAcknowleged", "true");
        handleUpload(__assign({}, uploadArgs));
        setShowModal(false);
    };
    var localize = (0, utilsOolib_1.useLocale)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AspectRatioShell_1.default, { aspectRatio: aspectRatio, containerShape: containerShape, stretchToFullHeight: stretchToFullHeight, onShellPrepared: decideUIStyle },
            react_1.default.createElement(FileUploadWrapper_1.FileUploadWrapper, { styledPlaceholderWrapperRef: styledPlaceholderWrapperRef, uploadProgress: uploadProgress, isLoading: isLoading, containerShape: containerShape, multiple: multiple, smallPlaceholderUI: smallPlaceholderUI, mediaType: "image", handleUpload: handleUpload, onChange: onChange, value: value, id: id, inputRef: inputRef },
                smallPlaceholderUI ? (react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement(ImageSquare, { size: 16, color: greyColor100 }),
                    react_1.default.createElement(Typo_1.SANS_0, { semibold: true }, dropzoneLabel),
                    showOptionalLabelInDropzone && isRequired === false && (react_1.default.createElement(Typo_1.SANS_0, null, "(optional)")))) : (react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement(ImageSquare, { size: 30, color: greyColor100 }),
                    react_1.default.createElement(Typo_1.SANS_2, { semibold: true }, "".concat(localize(dropzoneLabel), " ").concat(showOptionalLabelInDropzone && isRequired === false
                        ? "(optional)"
                        : "")),
                    react_1.default.createElement(Typo_1.SANS_2, null, dropzoneSublabel))),
                showImageUploadCaution.enable ? (react_1.default.createElement(styled_1.StyledCautionMsg, null,
                    react_1.default.createElement("div", { style: { flex: 0 } }, (0, genIcon_1.genIcon)({ icon: "Info" })),
                    react_1.default.createElement(Typo_1.SANS_3, { style: { textAlign: "left" } }, showImageUploadCaution.subTitle))) : null)),
        showModal ? (react_1.default.createElement(ModalConfirm_1.ModalConfirm, __assign({}, showImageUploadCaution, { onClose: function () { return setShowModal(false); }, onConfirm: handleOnConfirm }))) : null));
};
exports.default = Placeholder;
